<template>
    <section>
	
        <!--<div class="container">
            <div class="row">
                <div class="col p-5">
                    <h1 class="font-weight-bold text-danger text-uppercase text-center mb-4">Pendaftaran Siswa BTA Group 2023/2024</h1>
                    <p class="font-weight-medium mb-5">
                        Mohon diisi form berikut secara lengkap dan benar. 
			Setelah selesai mengisi sampai tahap akhir, akan mendapatkan pesan konfirmasi yang masuk ke e-mail yang terdaftar.
                    </p>
		    
		    <h2 class="font-weight-bold text-danger text-uppercase text-center mb-5">
                        Produk Kami
                    </h2>

                    <div class="row">
                        <div class="col-12 col-lg-6 mb-5" v-for="product in products">
                            <div class="row mb-3">
                                <div class="col-7 pr-2">
                                    <img v-bind:src="product.imageUrl" class="img-fluid w-100" />
                                </div>
                                <div class="col-5 pl-2">
                                    <h3 class="font-weight-bold text-danger text-uppercase">{{ product.name }}</h3>
                                    <h3 class="font-weight-bold">{{ product.price | currency }}</h3>
                                    <a href="#" v-on:click.prevent="modal = true; reference = product" class="d-block mb-5">
                                        Cabang Tersedia
                                    </a>
                                    <router-link v-bind:to="{ name: 'product/registration', params: {id: product.id} }" class="btn btn-danger btn-sm position-absolute px-5 mx-2" style="left: 0px; bottom: 0px;">
                                        Pilih
                                    </router-link>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <p class="font-weight-medium">
                                        {{ product.description }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
        
        <div>
        <!--<iframe width="100%" height="500" src="https://datastudio.google.com/embed/reporting/9c554a97-2d87-49b2-9b05-a97e41f41e64/page/N7NnC" frameborder="0" style="border:0" allowfullscreen></iframe>-->    
          <div class="row">
            <div class="col-12 mx-auto align-items-center text-center">
              <h3 class="fw-light fs-3 fs-lg-4 lh-sm mb-4">Klik logo Cabang untuk info lebih lanjut</h3>
              <div class="row h-100 justify-content-center">
                      <div class="col-sm-6 col-lg-4 col-xl-3 text-xl-start"><a href="https://api.whatsapp.com/send?phone=62811962322&text=Halo%2C+boleh+tanya+mengenai+Progam+Bimbingan+di+BTA+8+Jakarta%3F"><img class="mb-4" src="/static/images/page/about/bta8jakarta.png" alt="cabang"></a></div>
                      <div class="col-sm-6 col-lg-4 col-xl-3 text-xl-start"><a href="https://api.whatsapp.com/send?phone=628111834545&text=Halo%2C+boleh+tanya+mengenai+Progam+Bimbingan+di+BTA+45%3F"><img class="mb-4" src="/static/images/page/about/bta45.png" alt="cabang"></a></div>
                      <!-- <div class="col-sm-6 col-lg-4 col-xl-3 text-xl-start"><a href="https://api.whatsapp.com/send?phone=628111115055&text=Halo%2C+boleh+tanya+mengenai+Progam+Bimbingan+di+BTA+SMP+Tebet%3F"><img class="mb-4" src="/static/images/page/about/btasmp.png" alt="cabang"></a></div> -->
                      <div class="col-sm-6 col-lg-4 col-xl-3 text-xl-start"><a href="https://api.whatsapp.com/send?phone=6281291575317&text=Halo%2C+boleh+tanya+mengenai+Progam+Bimbingan+di+BTA+8+Duta%3F"><img class="mb-4" src="/static/images/page/about/btaduta.png" alt="cabang"></a></div>
                      <div class="col-sm-6 col-lg-4 col-xl-3 text-xl-start"><a href="https://api.whatsapp.com/send?phone=6282113115543&text=Halo%2C+boleh+tanya+mengenai+Progam+Bimbingan+di+BTA+8+Fatmawati%3F"><img class="mb-4" src="/static/images/page/about/btafatma.png" alt="cabang"></a></div>

                      <div class="col-sm-6 col-lg-4 col-xl-3 text-xl-start"><a href="https://api.whatsapp.com/send?phone=6281385408460&text=Halo%2C+boleh+tanya+mengenai+Progam+Bimbingan+di+BTA+8+Depok%3F"><img class="mb-4" src="/static/images/page/about/btadepok.png" alt="cabang"></a></div>

		      <div class="col-sm-6 col-lg-4 col-xl-3 text-xl-start"><a href="https://api.whatsapp.com/send?phone=6287885047302&text=Halo%2C+boleh+tanya+mengenai+Progam+Bimbingan+di+BTA+8+Kelapa+Gading%3F"><img class="mb-4" src="/static/images/page/about/btaKG.png" alt="cabang" width="35%"></a></div>
                    </div>
                  </div>
                
            </div>
         
        </div>
        <b-modal v-model="modal" v-on:hide="reference = null" size="lg" modal-class="border-0" header-class="background-primary" footer-class="justify-content-center" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Cabang-Cabang Tersedia
                </h4>
            </template>
            <div class="container px-5 py-2">
                <button v-on:click="modal = false" class="btn btn-sm btn-outline-danger px-5 mt-2 mb-3 d-block mx-auto">
                    Kembali
                </button>
                <p class="font-weight-medium text-center mb-1">
                    Berikut adalah cabang-cabang yang menyediakan:
                </p>
                <template v-if="reference">
                    <p class="font-weight-bold text-center">
                        {{ reference.name }}
                    </p>
                    <div class="row justify-content-center">
                        <div class="col-auto">
                            <h4 class="font-weight-bold">Cabang Utama:</h4>
                            <p class="mb-2">
                                <ul class="mb-0 pl-3 font-weight-medium">
                                    <li v-for="branch in primaryBranches">{{ branch.name }}</li>
                                </ul>  
                            </p>
                        </div>
                        <div class="col-auto">
                            <h4 class="font-weight-bold">Cabang Mitra:</h4>
                            <p class="mb-2">
                                <ul class="mb-0 pl-3 font-weight-medium">
                                    <li v-for="branch in partnerBranches">{{ branch.name }}</li>
                                </ul>  
                            </p>
                        </div>
                        <div class="col-auto">
                            <h4 class="font-weight-bold">Cabang PP:</h4>
                            <p class="mb-2">
                                <ul class="mb-0 pl-3 font-weight-medium">
                                    <li v-for="branch in otherBranches">{{ branch.name }}</li>
                                </ul>  
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </b-modal>
	<div class="row">
            <div class="col text-center mt-5">
                <Adsense v-bind:data-ad-client="googleAdsClientKey" data-ad-slot="8773918261"></Adsense>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "ProductIndex",
        data() {
            return {
                products: [],
		googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
                reference: null,
                modal: false
            };
        },
        computed: {
            primaryBranches() {
                return this.reference ? this.reference.branches.filter(branch => branch.isPrimary) : [];
            },
            partnerBranches() {
                return this.reference ? this.reference.branches.filter(branch => !branch.isPrimary && !branch.isHidden) : [];
            },
            otherBranches() {
                return this.reference ? this.reference.branches.filter(branch => !branch.isPrimary && branch.isHidden) : [];
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/product').then(response => {
                this.products = response.data.data;
            });
        },
        mounted() {
            document.title = 'Product - ' + process.env.APP_NAME;
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/product/Index.vue